import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class MotorStepService
{

    public StepNo:number;
    
        private subject = new Subject<any>();

        setStepNum(StepNo:number)
        {
            this.subject.next(StepNo);                
        }
       
    
        getStepNum(): Observable<string> {
            if(sessionStorage.getItem("MotorStep")!=null)
            { 
                 this.StepNo=Number(sessionStorage.getItem("MotorStep")); 
                 this.subject.next(this.StepNo);                                         
            }
            return this.subject.asObservable();
        }
    

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Services/MotorStepService.ts